import type { ReactNode } from "react";
import { TaskGroupBy, TaskPriority, TaskStatus } from "@common/types/task";
import { TaskPriority as TaskPriorityIcon } from "../TaskPrioritySelect/TaskPriority";
import { TASK_STATUS_CONFIG } from "../TaskStatusSelect/taskStatus.constants";

const TASK_STATUSES = Object.values(TaskStatus);
const TASK_PRIORITIES = Object.values(TaskPriority);

/** The icon List uses for a status or priority column; none for the others. */
export const getTaskColumnIcon = ({
    groupBy,
    groupKey,
}: {
    groupBy: TaskGroupBy;
    groupKey: string;
}): ReactNode => {
    if (groupBy === TaskGroupBy.STATUS) {
        const status = TASK_STATUSES.find((value) => value === groupKey);
        if (status === undefined) {
            return undefined;
        }
        const { Icon } = TASK_STATUS_CONFIG[status];
        return <Icon aria-hidden />;
    }
    if (groupBy === TaskGroupBy.PRIORITY) {
        const priority = TASK_PRIORITIES.find((value) => value === groupKey);
        return (
            <TaskPriorityIcon priority={priority ?? null} variant="iconOnly" />
        );
    }
    return undefined;
};
